import Navbar from "./component/Navbar";
import './styles/App.css'
import Home from "./component/Home";
import Footer from "./component/Footer";
function App() {
  return (
    <div className="App">
     <Navbar />
     <Home />
     <Footer />
    </div>
  );
}

export default App;
